<template>
  <div class="login-form">
    <div class="header">
      <img class="logo" src="../assets/erp.jpg" @click="handleTest()">
      <h1>
        啥都签智能软件服务平台
      </h1>
    </div>
    <a-form
        :form="form"
        class="content"
        @submit="handleSubmit"
    >
      <a-form-item>
        <a-input v-decorator="['username', { rules: [{ required: true, message: '请输入!' }] }]"
                 placeholder="账号">
          <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-decorator="[ 'password', { rules: [{ required: true, message: '请输入!' }] }, ]" type="password"
                 placeholder="密码">
          <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" class="login-form-button" :loading="loading">
          登录
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "Login",
  mixins: [HttpMixins],
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      url: {
        login: window._CONFIG['authURL'] + "/login",
      }
    }
  },
  methods: {
    handleTest() {
      this.$router.push({path: '/test'});
    },
    handleSubmit(e) {
      e.preventDefault();
      let that = this;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            localStorage.setItem('accessToken', 'Bearer ' + response.data.accessToken);
            localStorage.setItem('username', response.data.username);
            localStorage.setItem('permissionList', JSON.stringify(response.data.permissionList));
            that.$router.push({path: '/home'});
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      this.form.validateFields((err, values) => {
        if (!err) {
          let param = Object.assign({}, values);
          that.loading = true;
          that.$axios.post(that.url.login, param, {headers: that.headers, withCredentials: true})
              .then(handleSuccess)
              .catch((error) => that.catchError(error))
              .finally(() => {
                that.loading = false;
              });
        }
      });
    },
  }

};
</script>

<style scoped>

.login-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header {
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
}

.header .logo {
  width: 200px;
  margin: 0 auto 0;
  display: block;
}

.header h1 {
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  font-weight: bold;
}


.content {
  max-width: 300px;
  margin: 0 auto 0;
}


.content .login-form-button {
  width: 100%;
}

</style>
